import { motion } from "framer-motion";
import React, { Suspense, useContext, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import CustomLoaderLiquid from "../../components/CustomLoaderLiquid/customLoaderLiquid.component";
import { UserContext } from "../../services/AppContext/appProvider";

const DisplayPageProductsHomePage = React.lazy(
  () =>
    import(
      "../../components/DisplayPageProductsHomePage/displayPageProductsHomePage.component"
    )
);

const HomePage: React.FC = () => {
  const nav = useNavigate();
  const { isLoggedIn, setShowSignupModal } = useContext(UserContext);

  useLayoutEffect(() => {
    // get body element
    const body = document.querySelector("body");
    if (!body) return;

    body.classList.add("home-page");

    return () => {
      body.classList.remove("home-page");
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      className="mb-4"
    >
      <div className="container mx-auto">
        {/* banner */}
        <div
          // className="special-banner mx-2 cursor-pointer"
          className={`special-banner mx-2 ${isLoggedIn ? "" : "cursor-pointer"}`}
          onClick={() => {
            !isLoggedIn && setShowSignupModal(true);
            // nav("/item/20");
          }}
        >
          <picture>
            <source
              media="(min-width:768px)"
              srcSet={
                isLoggedIn
                  ? "/assets/images/banner_homepage_desktop_user.png"
                  : "/assets/images/banner_homepage_desktop.png"
              }
            />
            <img
              srcSet={
                isLoggedIn
                  ? "/assets/images/banner_homepage_mobile_user.png"
                  : "/assets/images/banner_homepage_mobile.png"
              }
              alt="banner"
              className="m-auto max-h-[600px] max-w-full rounded-lg shadow-xl md:block md:max-h-[340px]"
            />
          </picture>
        </div>
        {/* <div className="divider"></div> */}
        <Suspense
          fallback={
            <div className="container mx-auto mt-4 px-4">
              <CustomLoaderLiquid />
            </div>
          }
        >
          <div className="px-5 md:px-0">
            <DisplayPageProductsHomePage type="homepage" />
          </div>
        </Suspense>
      </div>
    </motion.div>
  );
};

export default HomePage;
